import React from "react";

const Select = ({ name, status, label, options, error, ...rest }) => {
  return (
    <div className="input-group">
      <label htmlFor={name}>{label}</label>
      <select name={name} id={name} {...rest} className="input">
        {options.map((option) => (
          <option
            key={option.id}
            value={option.id}
            selected={Number(status) === option.id}
          >
            {option.name}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Select;
